module.exports = __webpack_public_path__ + "img/android-home-02.5a26488e.jpg";